<template>
  <!-- <div class="bk-container bk-personal_center clearfix"> -->
    <div>
      <div class="left-wrapper">
        <ul class="account-list list-box">
          <li v-show="isWhiteUser">
            <router-link to="/s-mart/personal_center/works/" exact>我上传的({{uploadNum}})</router-link>
          </li>
          <li>
            <router-link to="/s-mart/personal_center/works/download">我下载的({{total.total}})</router-link>
          </li>
        </ul>
      </div>
      <div class="right-wrapper">
        <router-view :total.sync="total" :uploadNum.sync="uploadNum"></router-view>
        <!-- <router-view :uploadNum="uploadNum"></router-view> -->
      </div>
    </div>
  <!-- </div> -->
</template>

<script type="text/javascript">
  export default {
    data() {
      return {
        uploadNum: 0,
        isWhiteUser: false,
        total: {
          total: 0
        }
      }
    },
    methods: {
      initWhiteUser () {
        axios.get(myUrl + `packman/ee/list/`).then((res) => {
          if (res.data.result && res.data.data.length) {
            this.isWhiteUser = true
          }
        })
      },
      getUploadData () {
        // 请求参数
        let params = {};
        params['page'] = 1;
        params['per_page'] = 10;
        axios.post(myUrl + "core/i/product/filter/", qs.stringify(params)).then((res) => {
          res = res.data
          if (res.result) {
            this.uploadNum = res.data.items.length
          }
        })
      },
      getDownloadData () {
        axios.post(myUrl + 'sns/download/product/').then((res) => {
          res = res.data;
          if(res.result){
            this.total.total = res.data.page.total;  // 返回总数
          }
        })
      }
    },
    mounted () {
      this.initWhiteUser()
      this.getDownloadData()
      this.getUploadData()
    }
  }
</script>

<style media="screen" lang="scss">
  .content-none{
    /*display:none;*/
    margin: 135px 0;
    text-align: center;
    p{
      margin-top: 25px;
      font-size: 16px;
      color: #878996;
      a{
        color: #57a3f1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// works.vue?46995d8b